import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Lazyload } from 'vant'
import 'amfe-flexible'

// 按需引入Vant组件
import {
  Button,
  Tabbar,
  TabbarItem,
  NavBar,
  Icon,
  Swipe,
  SwipeItem,
  Grid,
  GridItem,
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Search,
  Tab,
  Tabs,
  PullRefresh,
  List,
  Field,
  ActionSheet
} from 'vant'

Vue.config.productionTip = false

// 使用Vant组件
Vue
  .use(Button)
  .use(Tabbar)
  .use(TabbarItem)
  .use(NavBar)
  .use(Icon)
  .use(Swipe)
  .use(SwipeItem)
  .use(Grid)
  .use(GridItem)
  .use(Cell)
  .use(CellGroup)
  .use(Toast)
  .use(Dialog)
  .use(Search)
  .use(Tab)
  .use(Tabs)
  .use(PullRefresh)
  .use(List)
  .use(Field)
  .use(ActionSheet)
  .use(Lazyload)

// 全局注入axios
import axios from '@/utils/request'
Vue.prototype.$axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')